import FounderSection from "../components/sections/FounderSection";
import Testimonials from "../components/sections/Testimonials";
import ClientTicker from "../components/sections/ClientTicker";
import ContactSplit from "../components/sections/ContactSplit";
import { MaskedLine, MaskedLineInView } from "../components/MaskedLine";

export default function AboutPage() {
  return (
    <main data-testid="page-about">
      <section className="ground-paper pt-[104px] pb-14 md:pt-[132px] md:pb-20">
        <div className="wrap">
          <div className="flex items-center gap-4 mb-10">
            <span className="series-stamp"><span>About the studio</span></span>
            <span className="stamp-dim">Est. 2015</span>
          </div>
          <h1 className="h-hero max-w-[1200px]" style={{ fontSize: "clamp(56px, 9vw, 156px)" }}>
            <MaskedLine>A firm built by</MaskedLine>
            <MaskedLine delay={0.1}>a <span className="claim">trainer.</span></MaskedLine>
            <MaskedLine delay={0.2}>Not by a brochure<span className="tension">.</span></MaskedLine>
          </h1>
          <p className="aside mt-10 max-w-[720px]">
            This is Jasmeen Kaur&rsquo;s practice — a decade of enterprise rooms compressed into a research-backed studio for communication, voice and leadership. Every method, every drill, every framework was tested in a real room before it ever made it to a deck.
          </p>
        </div>
      </section>

      <ClientTicker />

      <section className="ground-highlighter sec-pad">
        <div className="wrap grid lg:grid-cols-3 gap-8 md:gap-12">
          {[
            {
              n: "01",
              t: "Behaviour change, not certificates.",
              b: "Training that does not change behaviour is theatre. Every program is designed around what people will actually do differently on Monday morning — and how their managers will see it."
            },
            {
              n: "02",
              t: "Seventy per cent practice. Thirty per cent framework.",
              b: "Every module ends in a live simulation. Recorded. Reviewed. Re-run. Our learners do not leave with notes — they leave with reps."
            },
            {
              n: "03",
              t: "Built for senior rooms.",
              b: "Every drill is calibrated to the level of room our learners are about to enter. If it does not work in front of a steering committee, it does not make it into our curriculum."
            }
          ].map((c) => (
            <div key={c.n} className="border-t-[1.5px] border-[color:var(--ink)] pt-6">
              <span className="stamp">Principle {c.n}</span>
              <h3 className="h-tile mt-6" style={{ fontSize: 26, lineHeight: 1.1 }}>
                <MaskedLineInView>{c.t}</MaskedLineInView>
              </h3>
              <p className="font-aside mt-6 text-[18px]" style={{ lineHeight: 1.55 }}>{c.b}</p>
            </div>
          ))}
        </div>

        <div className="wrap mt-20 max-w-[820px]">
          <span className="series-stamp"><span>Recognised on</span></span>
          <p className="font-aside mt-6 text-[22px]" style={{ lineHeight: 1.5 }}>
            Josh Talks · British Council · TISS · and 30+ enterprise partners across India and Australia.
          </p>
        </div>
      </section>

      <FounderSection />
      <Testimonials />
      <ContactSplit />
    </main>
  );
}
